export type WorkerRssFields = {
  workingSetBytes?: number | null;
  peakWorkingSetBytes?: number | null;
};

const MIB = 1024 * 1024;

export function formatWorkerRssMib(bytes: number | null | undefined): string {
  if (bytes == null || bytes <= 0) {
    return '—';
  }
  const mib = bytes / MIB;
  if (mib < 0.1) {
    return '< 0.1 MiB';
  }
  return `${mib.toFixed(1)} MiB`;
}

export function workerRssLabels(worker: WorkerRssFields): { rssLabel: string; peakRssLabel: string } {
  return {
    rssLabel: formatWorkerRssMib(worker.workingSetBytes),
    peakRssLabel: formatWorkerRssMib(worker.peakWorkingSetBytes),
  };
}
